import React, { useEffect, useState } from "react";
import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { loadLinks, loadAnnouncements, loadSettings, saveAnnouncements } from "./services/storageService";
import LoginPage from "./components/LoginPage";
import PortalPage from "./pages/PortalPage";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

export default function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </MsalProvider>
  );
}

function AppRouter() {
  const isAuthenticated = useIsAuthenticated();
  const { loading } = useAuth();
  const [linksData, setLinksData] = useState(null);
  const [announcementsData, setAnnouncementsData] = useState(null);
  const [settingsData, setSettingsData] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      loadLinks().then(setLinksData);
      loadAnnouncements().then(async data => {
        const now = new Date();
        const list = Array.isArray(data?.announcements) ? data.announcements : [];
        let changed = false;
        // Migração: recados sem data de expiração recebem 1 ano a partir de agora
        // (10 anos se forem fixos). Rodada uma única vez — depois todos têm expiresAt.
        const backfilled = list.map(a => {
          if (a.expiresAt) return a;
          changed = true;
          const exp = new Date(now);
          exp.setFullYear(exp.getFullYear() + (a.pinned ? 10 : 1));
          return { ...a, expiresAt: exp.toISOString() };
        });
        // Remove recados expirados permanentemente do blob na carga
        const valid = backfilled.filter(a => !a.expiresAt || new Date(a.expiresAt) > now);
        if (valid.length !== backfilled.length) changed = true;
        if (changed) {
          const cleaned = { announcements: valid };
          try {
            await saveAnnouncements(cleaned);
          } catch (err) {
            // Se falhar a escrita (ex: SAS read-only ou sem rede), segue com o resultado em memória
            console.warn("Falha ao atualizar recados no blob:", err);
          }
          setAnnouncementsData(cleaned);
        } else {
          setAnnouncementsData(data);
        }
      });
      loadSettings().then(setSettingsData);
    }
  }, [isAuthenticated]);

  if (loading) {
    return <div className="loading-page">Verificando autenticação…</div>;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  if (!linksData || !announcementsData || !settingsData) {
    return <div className="loading-page">Carregando portal…</div>;
  }

  return (
    <PortalPage
      linksData={linksData}
      onLinksUpdate={setLinksData}
      announcementsData={announcementsData}
      onAnnouncementsUpdate={setAnnouncementsData}
      settingsData={settingsData}
      onSettingsUpdate={setSettingsData}
    />
  );
}
